import {fetchFilterData} from '../../services/filterData';
import ActionTypes from  "./types";
import axios from "axios";
import { errorLogger } from "../../services/errorLogger";
import { BASE_URL } from "../../utils/constants";

// A response may arrive after logout/login or after switching publisher view.
const captureReportSession = (getState) => {
    const {authReducer: auth, reportReducer: report} = getState();
    return () => {
        const current = getState();
        return current.authReducer.isAuthenticated &&
            current.authReducer.sessionId === auth.sessionId &&
            current.authReducer.token === auth.token &&
            current.reportReducer.publisherView === report.publisherView;
    };
};

const changePeriod = (value) => (dispatch) => dispatch({type: ActionTypes.CHANGE_PERIOD, payload: value});
const changeDimension = (value, type = ActionTypes.CHANGE_DIMENSION) => (dispatch) => dispatch({type, payload: value});
const changeFilter = (value) => (dispatch) => dispatch({type: ActionTypes.CHANGE_FILTER, payload: value});
const changeDashboardFilters = (scope, rules) => (dispatch) => dispatch({
    type: ActionTypes.CHANGE_DASHBOARD_FILTERS,
    payload: {scope, rules}
});
const changePublisherView = (value) => (dispatch) => dispatch({type: ActionTypes.CHANGE_PUBLISHER_VIEW, payload: value});
const changeDateSplit = (value, type = ActionTypes.SWITCH_SPLIT_MODE) => (dispatch) => dispatch({type, payload: value});
const changeIsDeal = (value, type = ActionTypes.SWITCH_IS_DEAL) => (dispatch) => dispatch({type, payload: value});

let filterRequestId = 0;
const loadingFilterData = (data) => (dispatch, getState) => {
    const requestId = ++filterRequestId;
    dispatch({type: ActionTypes.LOADING_FILTER_DATA, payload: null});
    const isCurrentSession = captureReportSession(getState);
    return fetchFilterData(getState().authReducer, data)
            .then(data => {
                if (!isCurrentSession() || requestId !== filterRequestId) return;
                dispatch({
                    type: ActionTypes.LOADING_FILTER_DATA,
                    payload: data
                });
            })
            .catch((err) => isCurrentSession() && requestId === filterRequestId && errorLogger(
                                dispatch, 
                                err, 
                                ActionTypes.LOADING_FILTER_DATA_FAIL
                            )
            );
}

const getData = (data, cb, reload) => (dispatch, getState) => {
    const isCurrentSession = captureReportSession(getState);
    return axios.get(`${BASE_URL}/api/reports`, {params: data})
            .then(({data}) => {
                if (!isCurrentSession()) return;
                dispatch({type: ActionTypes.GET_DATA_SUCCESS});
                if (data?.success){
                    cb(data?.report, data?.cardMetrics)
                    reload(true)
                }
            })
            .catch((err) => isCurrentSession() && errorLogger(
                                dispatch, 
                                err, 
                                ActionTypes.GET_DATA_FAIL
                            )
            );
}

const getTrends = (data, cb, reload) => (dispatch, getState) => {
    const isCurrentSession = captureReportSession(getState);
    return axios.get(`${BASE_URL}/api/reports/trends`, {params: data})
            .then(({data}) => {
                if (!isCurrentSession()) return;
                dispatch({type: ActionTypes.GET_TRENDS});
                if (data?.success){
                    cb({current: data?.current, reference: data?.reference})
                    reload(true)
                }
            })
            .catch((err) => isCurrentSession() && errorLogger(
                                dispatch, 
                                err, 
                                ActionTypes.GET_TRENDS_FAIL
                            )
            );
}

const getDealsData = (data, cb, reload) => (dispatch, getState) => {
    const isCurrentSession = captureReportSession(getState);
    return axios.get(`${BASE_URL}/api/reports/deals`, {params: data})
            .then(({data}) => {
                if (!isCurrentSession()) return;
                dispatch({type: ActionTypes.GET_DEALS_DATA_SUCCESS});
                if (data?.success){
                    cb(data?.report)
                    reload(true)
                }
            })
            .catch((err) => isCurrentSession() && errorLogger(
                                dispatch, 
                                err, 
                                ActionTypes.GET_DEALS_DATA_FAIL
                            )
            );
}

const getDirectCampaignsData = (data, cb, reload) => (dispatch, getState) => {
    const isCurrentSession = captureReportSession(getState);
    return axios.get(`${BASE_URL}/api/reports/direct-campaigns`, {params: data})
            .then(({data}) => {
                if (!isCurrentSession()) return;
                dispatch({type: ActionTypes.GET_DEALS_DATA_SUCCESS});
                if (data?.success){
                    cb(data?.report)
                    reload(true)
                }
            })
            .catch((err) => isCurrentSession() && errorLogger(
                                dispatch, 
                                err, 
                                ActionTypes.GET_DEALS_DATA_FAIL
                            )
            );
}

const getComparisonData = (params, cb, onError) => (dispatch, getState) => {
    const isCurrentSession = captureReportSession(getState);
  return axios.get(`${BASE_URL}/api/reports/compare`, { params })
    .then(({ data }) => {
      if (!isCurrentSession()) return;
      if (!data?.success || !Array.isArray(data.comparison)) {
        throw new Error('Invalid comparison response');
      }
      dispatch({ type: ActionTypes.GET_COMPARISON_DATA });
      if (cb) cb(data.comparison);
    })
    .catch((err) => {
      if (!isCurrentSession()) return;
      if (onError) onError(err);
      return errorLogger(dispatch, err, ActionTypes.GET_COMPARISON_DATA_FAIL);
    });
};

const getDealsDetailData = (params) => (dispatch, getState) => {
    const isCurrentSession = captureReportSession(getState);
  return axios.get(`${BASE_URL}/api/reports/deals`, { params })
    .then(({ data }) => {
      if (!isCurrentSession()) return;
      if (!data?.success || !Array.isArray(data.report)) {
        throw new Error('Invalid deals response');
      }
      return data.report;
    })
    .catch((err) => {
      if (!isCurrentSession()) return;
      throw err;
    });
};

const createReport = (data, cb) => (dispatch, getState) => {
    const isCurrentSession = captureReportSession(getState);
    return axios.get(`${BASE_URL}/api/reports/create`, {params: data})
            .then(({data}) => {
                if (!isCurrentSession()) return;
                dispatch({type: ActionTypes.CREATE_REPORT});
                if (data?.success){cb(data?.report)}
            })
            .catch((err) => isCurrentSession() && errorLogger(
                                dispatch, 
                                err, 
                                ActionTypes.CREATE_REPORT_FAIL
                            )
            );
}

export {
    changePeriod,
    changeDimension,
    changeFilter,
    changeDashboardFilters,
    changePublisherView,
    loadingFilterData,
    getData,
    getComparisonData,
    getDealsData,
    createReport,
    getTrends,
    changeDateSplit,
    changeIsDeal,
    getDirectCampaignsData,
    getDealsDetailData
}